import React, { useEffect, useState } from 'react';
import AdventureCard from './TourPackages/Cards/AdventureCard';
import { PackageDTO, CategoryDTO, fetchCategories } from './TourPackages/CategoryService';
import LoadingSpinner from '../Utilities/LoadSpinner'; // Import LoadingSpinner

interface PackageBookingProps {
  dateRange: { startDate: Date; endDate: Date };
  setDateRange: (dateRange: { startDate: Date; endDate: Date }) => void;
  fetchCartItems: () => Promise<any[]>; // Add fetchCartItems prop
}

const PackageBooking: React.FC<PackageBookingProps> = ({ fetchCartItems }) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const [packages, setPackages] = useState<PackageDTO[]>([]);
  const [categories, setCategories] = useState<CategoryDTO[]>([]);
  const [loading, setLoading] = useState(true); // Add loading state

  const loadCategories = async () => {
    if (apiUrl) {
      const response = await fetchCategories(apiUrl);
      setCategories(response);
      const allPackages = response.flatMap(category => category.packages);
      console.log('All packages:', allPackages);
      setPackages(allPackages);
      setLoading(false); // Set loading to false after data is fetched
    }
  };

  useEffect(() => {
    loadCategories();
    fetchCartItems(); // Fetch cart items when the component mounts
  }, [apiUrl, fetchCartItems]);

  if (loading) {
    return <LoadingSpinner />; // Show LoadingSpinner while loading
  }

  return (
    <section>
      <div className="package-list">
        {packages.map(pkg => (
          <AdventureCard
            key={pkg.id}
            packageDTO={pkg}
            onBookNow={(packageId: number) => {
              console.log(`Book now clicked for packageId: ${packageId}`);
            }}
            fetchCartItems={fetchCartItems} // Pass fetchCartItems to AdventureCard
          />
        ))}
      </div>
    </section>
  );
};

export default PackageBooking;